import { Component, inject, signal, DOCUMENT, computed } from '@angular/core';
import { AuthStore } from '../../core/auth/auth.store';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ROUTER_TOKENS } from '../../app.routes';
import { USER_ROLE } from '../../core/auth/auth.interface';
// Service
import { AuthService } from '@auth0/auth0-angular';
import { CompanyService, ICompany, ICompanyReturn } from '../../core/company/company.service';
import { UserService } from '../../core/user/user.service';
import { LoggingService } from '../../core/utils/logging.service';
// PrimeNG
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ImageModule } from 'primeng/image';
import { StyleClassModule } from 'primeng/styleclass';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';
import { TranslocoModule } from '@jsverse/transloco';

const PRIMENG = [AvatarModule, AvatarGroupModule, ImageModule, StyleClassModule, TieredMenuModule];

export interface IUserLabel {
  userImgPath: string;
  firstName: string;
  lastName: string;
}

@Component({
  selector: 'app-choose-company',
  imports: [RouterModule, ...PRIMENG, LanguageConfigComponent, TranslocoModule],
  templateUrl: './choose-company.component.html',
  styleUrl: './choose-company.component.scss',
})
export class ChooseCompanyComponent {
  // Injectable Service
  private router = inject(Router);
  private companyService = inject(CompanyService);
  private auth0 = inject(AuthService);
  private doc = inject(DOCUMENT);
  private userService = inject(UserService);
  private authStore = inject(AuthStore);
  private readonly loggingService = inject(LoggingService);

  constructor() {
    this.loggingService.warn('🧩1️⃣@@@ChooseCompanyComponent');
  }

  s3BlobPath = environment.s3.pubBlob;

  userAtt = signal<IUserLabel>({
    userImgPath: this.authStore.userSystem!.avatarUrl?.startsWith('https:')
      ? this.authStore.userSystem!.avatarUrl
      : `${this.s3BlobPath}${this.authStore.userSystem!.avatarUrl}`,
    firstName: this.authStore.userSystem!.firstName as string,
    lastName: this.authStore.userSystem!.lastName as string,
  });

  menuItems = signal<MenuItem[]>([
    {
      label: 'Sign out',
      icon: 'pi pi-sign-out',
      command: () => {
        this.signOut();
      },
    },
  ]);

  // Company Variable
  companyList = this.companyService.getCompanyListSignal();
  // companyList = signal<any>([]);
  compSelected = signal<ICompany | undefined>(undefined);

  // Permission
  permissionManage = signal<boolean>(this.authStore.systemManage);
  hasCommercePermissionsComputed = computed(() => this.hasPermission('dashboard-manage'));

  onSelectComp(company?: ICompanyReturn) {
    this.loggingService.warn('Event', company);
    if (company) {
      const { role, subRole } = this.authStore;
      this.loggingService.warn('role', role, 'roleId', subRole);
      this.companyService.setCompanyState(company);
      // Admin And staff Get Permission in company
      if (role === USER_ROLE.ADMIN || role === USER_ROLE.STAFF) {
        this.authStore.setRoleAdminStaffState(subRole);
        // this.router.navigate([`${ROUTER_TOKENS.APP}`]);
        this.loggingService.warn('||| hasCommercePermissionsComputed :: =>', this.hasCommercePermissionsComputed());
        if (this.hasCommercePermissionsComputed()) {
          this.router.navigate([`${ROUTER_TOKENS.APP}/${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.HOME}`]);
        } else {
          this.router.navigate([`${ROUTER_TOKENS.APP}`]);
        }
        // this.userService.getRoleDetail(role, roleId).subscribe((res) => {
        //   this.loggingService.warn('getRoleDetail Admin Staff',res);
        //   this.authStore.setRoleAdminStaffState(res);
        //   this.router.navigate([`${ROUTER_TOKENS.APP}`]);
        // });
      } else {
        this.router.navigate([`${ROUTER_TOKENS.APP}/${ROUTER_TOKENS.COMP}`]);
      }
    } else {
      this.companyService.clearCompanyState();
      this.router.navigate([`${ROUTER_TOKENS.APP}/${ROUTER_TOKENS.BIZ}`]);
    }
  }

  manageImageEmpty() {
    const firstName = this.userService.manageImageEmpty(this.userAtt().firstName);
    const lastName = this.userService.manageImageEmpty(this.userAtt().lastName);
    return firstName + lastName;
  }

  hasPermission(key: string): boolean {
    if (!key) return false;
    return this.userService.conditionsPermissionByKey(key);
  }

  signOut() {
    this.loggingService.warn('Func | signOut');
    this.authStore.clearState();
    this.auth0.logout({
      logoutParams: {
        returnTo: this.doc.location.origin,
      },
    });
    // this.router.navigate([`/`]);
  }
}
